import {FileUpload} from '@/components/atoms'
import {generateVideoThumbnailFromUrl, revokeThumbnailUrl} from '@/helpers/mediaThumbnail'
import {Constants, SUPPORTED_PRODUCT_MEDIA} from '@/utils/constants/commonConstants'
import {useSortable} from '@dnd-kit/react/sortable'
import {useEffect, useMemo, useState} from 'react'

const supportedProductMediaExtensions = SUPPORTED_PRODUCT_MEDIA.join(',')
const supportedProductMediaDescription = SUPPORTED_PRODUCT_MEDIA.join(', ')

export const MediaSlotItem = ({
  slot,
  isUploading,
  handleUpload,
  handleUploadError,
  handleDeleteImage,
  handleDeleteFromServer,
}) => {
  const {ref, handleRef, isDragging} = useSortable({
    id: slot.slotId || `slot-${slot.displayOrder}`,
    index: slot.displayOrder - 1,
    disabled: isUploading,
  })

  const hasError = slot.error.feedbackType === 'error'
  const [videoThumbnailUri, setVideoThumbnailUri] = useState('')

  const isVideoSlot = useMemo(() => slot?.metadata?.mediaType === 'VIDEO', [slot?.metadata?.mediaType])

  useEffect(() => {
    if(slot?.file ) 
   return   setVideoThumbnailUri(slot.imageUri)
    let isMounted = true
    let generatedThumbnailUri = ''
    const createThumbnail = async () => {
      if (!isVideoSlot || slot?.file || !slot?.imageUri) {
        setVideoThumbnailUri('')
        return
      }

      try {
        generatedThumbnailUri = await generateVideoThumbnailFromUrl(slot.imageUri, {
          maxWidth: 468,
          maxHeight: 300,
          outputType: 'image/jpeg',
          quality: 0.85,
          captureAtSecond: 1,
        })

        if (isMounted) {
          setVideoThumbnailUri(generatedThumbnailUri)
        }
      } catch {
        if (isMounted) {
          setVideoThumbnailUri('')
        }
      }
    }

    createThumbnail()

    return () => {
      isMounted = false
      revokeThumbnailUrl(generatedThumbnailUri)
    }
  }, [isVideoSlot, slot?.file, slot?.imageUri])

  const displayImageUri = isVideoSlot ? videoThumbnailUri || '' : slot?.imageUri || ''

  return (
    <div ref={ref} className={`relative flex flex-col gap-4 rounded-lg border border-gray-600 p-4 ${isDragging ? 'opacity-60' : ''}`}>
      <div
        title="Drag to reorder"
        ref={handleRef}
        className="absolute right-3 top-3 z-10 cursor-grab rounded border border-gray-500 px-2 py-1 text-xs text-gray-300"
      >
        Drag
      </div>
      <FileUpload
        acceptedExtensions={supportedProductMediaExtensions}
        description={`Drag and drop your file here (only ${supportedProductMediaDescription})`}
        variant={slot.uploading ? Constants.Uploading : Constants.Edit}
        buttonLabel="Select from System Library"
        onUpload={file => handleUpload(slot.displayOrder, file)}
        onUploadError={error => handleUploadError(slot.displayOrder, error)}
        onUploadDelete={() =>
          slot.imageUri && !slot.file ? handleDeleteFromServer(slot.displayOrder) : handleDeleteImage(slot.displayOrder)
        }
        type="image"
        required={false}
        files={slot.file ? [slot.file] : []}
        imageUri={displayImageUri}
        isDark={true}
        feedbackType={slot.error.feedbackType}
        helperText={hasError ? slot.error.helperText : ''}
        dataTestId={`upload-image-${slot.displayOrder}`}
        disabled={isUploading}
      />
    </div>
  )
}
